import { useEffect } from 'react';

import { getAccessToken } from '../http/auth-storage';
import { useSessionIdentity } from './useSessionIdentity';

// Mesmo destino usado pelo AuthInterceptor/AuthGuard do Angular quando a sessão
// falta ou expira (ver redirectToAuthRoute em http/axios-instance.ts).
const LOGIN_ROUTE = '/pages/login';

interface RequireAuthProps {
  children: JSX.Element;
}

/**
 * Gate de autenticação do shell privado (LayoutShell): sem token, não monta
 * nenhum chrome — a decisão é síncrona, no mesmo tick do primeiro render, então
 * sidebar/navbar nunca chegam a pintar antes do redirect. Sem este gate, a rota
 * migrada resolvia para o LayoutShell só pelo path, independentemente de sessão,
 * e a saída para o login só ocorria depois de uma chamada HTTP falhar com
 * 401/403 (axios-instance.ts) — daí o flash da área autenticada no load inicial.
 */
export function RequireAuth({ children }: RequireAuthProps): JSX.Element | null {
  const authenticated = getAccessToken() != null;

  useSessionIdentity(authenticated);

  useEffect(() => {
    if (!authenticated) {
      window.location.hash = `#${LOGIN_ROUTE}`;
    }
  }, [authenticated]);

  return authenticated ? children : null;
}
